import { render, staticRenderFns } from "./mobile-device.vue?vue&type=template&id=3b4be88a&scoped=true"
import script from "./mobile-device.vue?vue&type=script&lang=js"
export * from "./mobile-device.vue?vue&type=script&lang=js"
import style0 from "./mobile-device.vue?vue&type=style&index=0&id=3b4be88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4be88a",
  null
  
)

export default component.exports